// extracted by mini-css-extract-plugin
module.exports = {"newBlogPost":"NewBlogPost_newBlogPost__xOgbn"};